<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <div>
      <div>
        <img src="/static/img/toolbox.png" alt="PBN 360">
      </div>
      <form class="m-t" role="form" method="POST" @submit.prevent="login">
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Username" v-model="username" required="">
        </div>
        <div class="form-group">
          <input type="password" class="form-control" placeholder="Password" v-model="password" required="">
        </div>
        <button type="submit" class="btn btn-primary block full-width m-b">Login</button>
        <p class="text-muted text-center"><small>by Aphex Media</small></p>
        <!-- <a href="#"><small>Forgot password?</small></a>
        <p class="text-muted text-center"><small>Do not have an account?</small></p>
        <a class="btn btn-sm btn-white btn-block" href="register.html">Create an account</a> -->
      </form>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login () {
      const params = new URLSearchParams()
      params.append('username', this.username)
      params.append('password', this.password)
      params.append('operator', 1)

      axios.post('/users/login', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(resp => {
        // localStorage.setItem('token', resp.data.token.token)
        let tokenVal = resp.data.token.token ? resp.data.token.token : resp.data.token
        localStorage.setItem('token', tokenVal)
        localStorage.setItem('user', JSON.stringify(resp.data.user))
        window.location = localStorage.getItem('redirect') ? localStorage.getItem('redirect') : '/'
      }).catch(error => {
        if (error) {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Invalid username or password'
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue